module.exports = __webpack_public_path__ + "static/media/icon-info.f6606b54.svg";